module.exports = __webpack_public_path__ + "img/krokets.aaf09e19.png";